import {errors} from '@wix/document-services-implementation'
import type {ErrorsPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (): PublicModuleDeclaration<ErrorsPublicAPI> {
    return {
        methods: {
            /**
             * Site error constants
             * @member documentServices
             */
            errors: errors as any
        }
    }
}
